import styled from '@emotion/styled';

// Outer container keeps the border visible while inner content scrolls
export const Container = styled.div`
  width: 100%;
  border: 0.5px solid color-mix(in srgb, ${({ theme }) => theme.colors.Gray} 20%, transparent);
  border-radius: ${({ theme }) => theme.radii.card};
  //overflow: hidden; /* keeps rounded corners when header sticks */
  background: ${({ theme }) => theme.colors.SurfaceCard};
`;

// Scroll area provides the scroll context for sticky header
export const ScrollArea = styled.div`
  max-height: calc(100% - 2px);
  //overflow: auto;
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 14px 0; /* расстояние между строками, без внешних полей слева/справа */

  thead th {
    padding-top: 16px;
    background-color: ${({ theme }) => theme.colors.SurfaceCard};
    color: ${({ theme }) => theme.colors.WhiteGray60};
    text-align: left;
    vertical-align: bottom;
    font-family: 'SF Pro Display', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0;
    position: sticky;
    top: 0;
    z-index: 0;

    &:first-of-type {
      border-top-left-radius: 8px;
    }

    &:last-of-type {
      border-top-right-radius: 8px;
    }
  }

  tbody tr {
    position: relative;
    background: ${({ theme }) => theme.colors.SurfaceCard};
  }

  tbody tr:not(:first-child)::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 0.5px;
    background: color-mix(in srgb, ${({ theme }) => theme.colors.Gray} 20%, transparent);

    /* растягиваем через возможные внутренние отступы обёртки */
    margin-left: -14px; /* компенсирует padding-inline контейнера, если он 14px */
    margin-right: -14px; /* подстройте под ваш фактический padding */
  }

  tbody td {
    height: 72px;
  }
`;
